"use strict";

import axios from "axios";

const PREFIX = process.env.VUE_APP_API_SPEXEC;

export default {
  prosesRequestSpExecutor(data) {
    return axios.post(`${PREFIX}`, data, {
      withCredentials: true,
    });
  },
};
